import { useEffect, useRef, useState } from "react";
import { Camera, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const CameraCapture = ({ open, onOpenChange, onCapture }) => {
  const videoRef = useRef();
  const streamRef = useRef();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!open) return;
    let cancelled = false;
    navigator.mediaDevices?.getUserMedia({ video: { facingMode: "user", width: { ideal: 1280 } }, audio: false })
      .then((stream) => {
        if (cancelled) return stream.getTracks().forEach((t) => t.stop());
        streamRef.current = stream;
        videoRef.current.srcObject = stream;
        setReady(true);
      })
      .catch(() => {
        toast.error("Kamera tidak dapat diakses. Izinkan akses kamera atau unggah file.");
        onOpenChange(false);
      });
    return () => {
      cancelled = true;
      setReady(false);
      streamRef.current?.getTracks().forEach((t) => t.stop());
    };
  }, [open, onOpenChange]);

  const capture = () => {
    const v = videoRef.current;
    const canvas = document.createElement("canvas");
    canvas.width = v.videoWidth;
    canvas.height = v.videoHeight;
    const ctx = canvas.getContext("2d");
    ctx.translate(canvas.width, 0);
    ctx.scale(-1, 1);
    ctx.drawImage(v, 0, 0);
    canvas.toBlob((blob) => {
      onOpenChange(false);
      onCapture(new File([blob], "swafoto.jpg", { type: "image/jpeg" }));
    }, "image/jpeg", 0.92);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-2xl max-w-xl" aria-describedby={undefined} data-testid="camera-dialog">
        <DialogHeader><DialogTitle>Ambil swafoto</DialogTitle></DialogHeader>
        <div className="relative rounded-2xl overflow-hidden bg-zinc-900 aspect-[4/3]">
          <video ref={videoRef} autoPlay playsInline muted className="w-full h-full object-cover -scale-x-100" data-testid="camera-video" />
          <div className="absolute inset-[22%_28%] pointer-events-none">
            <span className="corner tl" /><span className="corner tr" /><span className="corner bl" /><span className="corner br" />
          </div>
          {!ready && <div className="absolute inset-0 grid place-items-center text-zinc-400 text-sm"><RefreshCw className="h-5 w-5 animate-spin" /></div>}
        </div>
        <p className="text-xs text-zinc-500">Posisikan wajah di dalam bingkai, menghadap kamera dengan cahaya cukup.</p>
        <Button onClick={capture} disabled={!ready} className="rounded-xl h-11 bg-blue-600 hover:bg-blue-700" data-testid="camera-capture-button">
          <Camera className="mr-2 h-4 w-4" />Ambil foto & cari
        </Button>
      </DialogContent>
    </Dialog>
  );
};
